module.exports = __webpack_public_path__ + "static/media/dep-personalize.bf6f6b5f.png";